import { styled } from 'stitches.config'

export const BlogImageRoot = styled('div', {
  '& img': {
    maxWidth: '100%',
  },
})
